<template>
  <b-container>
    <b-row>
      <b-col>
        <validation-observer v-slot="{ invalid }" ref="form" class="form form-sm mx-auto">
          <b-form @submit.prevent="handleSubmit">
            <FormHeader class="mb-4 mb-lg-5">Reset Password</FormHeader>
            <PasswordRestrictionsList />
            
            <base-input
              v-model="formData.new_password1"
              rules="required"
              name="New Password"
              label="New Password"
              vid="new_password1"
              data-vv-as="password"
              type="password"
              payload-name="new_password1"
            ></base-input>

            <base-input
              v-model="formData.new_password2"
              rules="required|confirmed:new_password1"
              name="Confirm New Password"
              label="Confirm New Password"
              data-vv-as="password"
              type="password"
              payload-name="new_password2"
            ></base-input>

            <TermlyCheckbox v-model="formData.terms" />

            <base-button
              :disabled="invalid"
              :loading="formProcessing"
              type="primary"
              native-type="submit"
              size="lg"
              class="mt-4 mb-4"
              block
              >Set Password</base-button
            >
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from "vue";
import { defineComponent, reactive, ref } from "@vue/composition-api";
import { useRoute, useRouter } from "vue2-helpers/vue-router";

import AuthenticationService from "@services/authentication";

import FormHeader from "@components/FormHeader";
import PasswordRestrictionsList from "@components/PasswordRestrictionsList";
import TermlyCheckbox from "@components/Termly/TermlyCheckbox";

export default defineComponent({
  name: "ResetPassword",
  title: "Reset Password",
  components: {
    FormHeader,
    PasswordRestrictionsList,
    TermlyCheckbox,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const formProcessing = ref(false);
    const showTCModal = ref(false);
    const showPPModal = ref(false);

    const formData = reactive({
      uid: route.params.uid,
      token: route.params.token,
    });

    const handleSubmit = () => {
      formProcessing.value = true;

      AuthenticationService.changePassword(formData)
        .then((resp) => {
          const respData = JSON.parse(resp.data).data;

          Vue.prototype.$toasted.show(respData.detail);

          formProcessing.value = false;

          router.push({
            name: "Login",
          });
        })
        .catch((error) => {
          const errorData = JSON.parse(error.response.data).data;

          if (errorData.token) Vue.prototype.$toasted.show("Invalid token.");
          else Vue.prototype.$bus.$emit("field-error", errorData);

          formProcessing.value = false;
        });
    };

    return {
      formProcessing,
      formData,
      handleSubmit,
      showTCModal,
      showPPModal,
    };
  },
});
</script>
